import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { IntegrationStatus } from "@/components/dealer/settings/IntegrationStatus";
import { BusinessSettings } from "@/components/dealer/settings/BusinessSettings";
import { ValuationSettings } from "@/components/dealer/settings/ValuationSettings";
import { UsageSettings } from "@/components/dealer/settings/UsageSettings";
import { ContentSettings } from "@/components/dealer/settings/ContentSettings";
import { UsersSettings } from "@/components/dealer/settings/UsersSettings";
import { DataSettings } from "@/components/dealer/settings/DataSettings";
import { useAuth } from "@/lib/auth";
import { api, errMsg } from "@/lib/api";

const TABS = [
  ["business", "Business details", BusinessSettings], ["valuation", "Valuations", ValuationSettings],
  ["usage", "Costs & limits", UsageSettings], ["data", "Demo & test data", DataSettings],
  ["users", "Staff logins", UsersSettings], ["content", "Privacy & terms", ContentSettings], ["status", "System status", IntegrationStatus],
];

export default function Settings() {
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => api.get("/dealer/settings").then((r) => { setS(r.data); setTick((t) => t + 1); }), []);
  useEffect(() => { reload(); }, [reload]);
  const save = async (body, msg = "Settings saved") => {
    try {
      const { data } = await api.put("/dealer/settings", body);
      setS(data);
      setTick((t) => t + 1);
      toast.success(msg);
      return true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  };
  if (!s) return <p className="text-slate-500">Loading…</p>;
  const owner = user.role === "owner";
  return (
    <div className="space-y-5" data-testid="settings-page">
      <div>
        <h1 className="text-2xl font-extrabold text-slate-900 sm:text-3xl">Settings</h1>
        <p className="mt-1 text-sm text-slate-600">Set up once – you'll rarely need to change these.</p>
      </div>
      {!owner && <p className="rounded bg-slate-100 p-3 text-sm">Only the owner account can change settings.</p>}
      <Tabs defaultValue="business">
        <TabsList className="h-auto flex-wrap justify-start bg-white p-1">
          {TABS.map(([k, label]) => <TabsTrigger key={k} value={k} data-testid={`settings-tab-${k}`}>{label}</TabsTrigger>)}
        </TabsList>
        {TABS.map(([k, , C]) => (
          <TabsContent key={k} value={k} className="mt-4"><C s={s} save={save} reload={reload} owner={owner} tick={tick} /></TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
